// export const sidebarNavCohortSelector = (state) => state.sidebarNav.selectedCohort;
export const sidebarNavIsExpandedSelector = (state) => state.sidebarNav.isExpanded;
